import { BrowserRouter } from "react-router";
import { StandaloneNavigationGuard } from "@/components/standalone-navigation-guard";
import { ThemeProvider } from "@/components/theme-provider";
import { ToasterProvider } from "@/components/toaster-provider";
import { TooltipProvider } from "@/components/ui/tooltip";
import { StandaloneInstanceProvider } from "@/lib/context/standalone-instance-context";
import { QueryProvider } from "@/providers/query-provider";
import { AppShell } from "./app-shell";
import { ErrorBoundary } from "./error-boundary";
import { AppRouter } from "./router";

export function App() {
  return (
    <ErrorBoundary>
      <BrowserRouter>
        {/* QL-262 — standalone mode: the instance store and the navigation
            guard sit directly under the router so every navigate()/<Link>
            in the app (shell, routes, toasts) passes through the guard. */}
        <StandaloneInstanceProvider>
          <StandaloneNavigationGuard>
            <ThemeProvider
              attribute="class"
              defaultTheme="system"
              enableSystem
              disableTransitionOnChange
            >
              <QueryProvider>
                {/* One provider for the whole app so `<Button tooltip>` works
                    anywhere. delayDuration=0 because the native title attribute's
                    ~1.5s delay is exactly what the Tooltip component replaces. */}
                <TooltipProvider delayDuration={0}>
                  <AppShell>
                    <AppRouter />
                  </AppShell>
                </TooltipProvider>
              </QueryProvider>
              <ToasterProvider />
            </ThemeProvider>
          </StandaloneNavigationGuard>
        </StandaloneInstanceProvider>
      </BrowserRouter>
    </ErrorBoundary>
  );
}
